import { useAuth } from '@/contexts/AuthContext';
import { Clock, ShieldAlert } from 'lucide-react';

/**
 * Shown to any user whose account is still pending admin approval.
 * Rendered near the top of the app shell so it's persistent.
 */
export default function PendingApprovalBanner() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.approvalStatus !== 'pending') return null;
  // Admins are never gated
  if (user.role === 'company_admin' || user.role === 'super_admin') return null;

  return (
    <div
      className="bg-amber-50 border-b border-amber-300 px-4 py-3 flex items-start gap-3"
      role="status"
      data-testid="pending-approval-banner"
    >
      <Clock className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
      <div className="text-sm flex-1">
        <p className="font-semibold text-amber-900">
          Your account is pending administrator approval
        </p>
        <p className="text-amber-800 text-xs mt-0.5">
          You can browse assigned trainings, JSAs, and safety materials in read-only mode.
          Signing JSAs, submitting incident reports, and other compliance actions are
          disabled until your administrator approves you.
        </p>
      </div>
      <ShieldAlert className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
    </div>
  );
}
